import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import { history } from '../store'
import { FileCheck, CreditCard } from "lucide-react";
import { withNamespaces } from "react-i18next";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import AppRentalHeader from '../containers/AppRentalHeader'
import { postRedsys } from '../actions/qrs'
import { fetchCustomer } from '../actions/qrs'
import StepBarRental from '../components/StepBarRental'

class PaymentRentalView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      redsys: null,
      iva: 21,
      redsysSignature: null,
      redsysMerchant: null,
      redsysVersion: null,
      total: null,
      importeBase: null,
      importeIva: null,
      minutes: 5,
      seconds: 0,
      isTimeUp: false,
      newLockerPrice: 0,
      discountApplied: false,
      timeStamp: null,
    }

    this.toggle = this.toggle.bind(this);
    this.getLockerType = this.getLockerType.bind(this);

  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';
    
    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getIconColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.iconsColor || '#01315f';
  }

  componentDidMount() {

    const {
      zoneSelected,
      descriptionZone,
      selectedLocker,
      lockerPrice,
      lockerAssigned,
      prerentCode,
      prerentTime,
      totalDays,
      startDate,
      endDate,
      qrType,
      qr,
      timeStamp,
      customerName,
      mail,
      phoneNumber,
      newsletterAcceptance,
      confirmReservation,
      customerId
    } = this.props.location.state;

    const { t, i18n } = this.props

    //Idiomas Redsys - Castellano-001, Inglés-002, Catalán-003, Francés-004, Alemán-005, Holandés-006, Italiano-007, Sueco-008, Portugués-009, Valenciano-010, Polaco-011, Gallego-012 y Euskera-013.
    console.log("Language: " + i18n.language);

    console.log("Customer Name: " + customerName);

    let language = '001'

    switch (i18n.language) {
      case "es": language = '001'; break;
      case "en": language = '002'; break;
      case "it": language = '007'; break;
      case "gr": language = '005'; break;
      case "fr": language = '004'; break;
      case "pt": language = '009'; break;
    }

    //Discount temporary

    let newLockerPrice = lockerPrice;

    let discountApplied = false;

    {/*
    // Ensure lockerPrice is based on 5-day rate if totalDays > 5
    if (totalDays > 5) {
      const dailyRate = lockerPrice / totalDays; // Calculate the daily rate based on 5-day price
      newLockerPrice = dailyRate * 5; // Reduce the price for the excess days
      discountApplied = true;
    }
    */}

    // Update the state with discount status and adjusted locker price
    this.setState({ newLockerPrice, discountApplied });

    this.setState({ timeStamp: timeStamp }, () => {
      this.startCountdown();;
    });

    let redsysPetition = {}

    let paymentId = Math.floor((Math.random() * 1000000) + 1).toString()

    let redsysURLOK = `https://lockers-qr.vacway.es/TicketRentalView?lockerPrice=${newLockerPrice}&descriptionZone=${descriptionZone}&zoneSelected=${zoneSelected}&selectedLocker=${selectedLocker}&lockerAssigned=${lockerAssigned}&paymentId=${paymentId}&qrToken=${qr}&language=${i18n.language}&prerentCode=${prerentCode}&startDate=${startDate.toLocaleDateString()}&endDate=${endDate.toLocaleDateString()}&customerName=${encodeURIComponent(customerName)}&mail=${encodeURIComponent(mail)}&phoneNumber=${encodeURIComponent(phoneNumber)}&customerId=${customerId}`
    let redsysURLKO = `https://lockers-qr.vacway.es/PaymentRentalError?qr=${qr}&language=${i18n.language}`

    redsysPetition.price = Number(newLockerPrice.toFixed(2))
    redsysPetition.redsysURLOK = redsysURLOK
    redsysPetition.redsysURLKO = redsysURLKO
    redsysPetition.paymentId = paymentId

    redsysPetition.merchantCode = '351639505'
    redsysPetition.currency = '978'
    redsysPetition.terminal = '1'
    redsysPetition.merchantUrl = 'https://vacway.com'
    redsysPetition.secretKey = 'xhI+J4wrx0JKkeGqJ12j2+ErLNH9OpHM'
    redsysPetition.language = language

    this.props.fetchCustomer(customerId)
      .then((customer) => {

        redsysPetition.merchantCode = customer.response.Redsys.MERCHANTCODE
        redsysPetition.currency = customer.response.Redsys.CURRENCY
        redsysPetition.terminal = customer.response.Redsys.TERMINAL
        redsysPetition.merchantUrl = customer.response.Redsys.MERCHANTURL
        redsysPetition.secretKey = customer.response.Redsys.SECRETKEY

        console.log("redsysPetition: ", redsysPetition);

        this.props.postRedsys(redsysPetition)
          .then((answer) => {
            let answerRedsys = answer.response

            let redsysSignature = answerRedsys.Ds_Signature
            let redsysMerchant = answerRedsys.Ds_MerchantParameters
            let redsysVersion = answerRedsys.Ds_SignatureVersion

            this.TotalComponent();

            this.setState({ redsys: answerRedsys, redsysSignature: redsysSignature, redsysMerchant: redsysMerchant, redsysVersion: redsysVersion });

          })
          .catch((error) => {
            console.error(error);
          });

      })
      .catch((error) => {
        console.error(error);
      });

  }

  componentWillUnmount() {
    const { qr, lockerAssigned } = this.props.location.state;

    clearInterval(this.countdownInterval);

    history.push(`/qrsale/${qr}?lockerAssigned=${lockerAssigned}`)
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  goTo(number, e) {
    history.push(`/phoneView`)
  }

  handleRedirect = () => {
    const { qr, lockerAssigned } = this.props.location.state;
    history.push(`/qrsale/${qr}?lockerAssigned=${lockerAssigned}`)
  };

  startCountdown = () => {
    const { timeStamp } = this.state;
    // Convert timeStamp (a Date object) into a millisecond timestamp.
    const startTime = new Date(timeStamp).getTime();
    const duration = 5 * 60 * 1000; // 5 minutes in ms
    const endTime = startTime + duration;

    this.countdownInterval = setInterval(() => {
      const now = Date.now();
      const diff = endTime - now;
      if (diff <= 0) {
        clearInterval(this.countdownInterval);
        this.setState({ minutes: 0, seconds: 0, isTimeUp: true });
      } else {
        const minutes = Math.floor(diff / (60 * 1000));
        const seconds = Math.floor((diff % (60 * 1000)) / 1000);
        this.setState({ minutes, seconds });
      }
    }, 250);
  };

  TotalComponent() {
    const { iva, newLockerPrice } = this.state;

    let importeBase = (newLockerPrice / (1 + (iva / 100))).toFixed(2)
    let importeIva = (newLockerPrice - importeBase).toFixed(2)
    let total = newLockerPrice.toFixed(2)

    this.setState({ importeBase: importeBase, importeIva: importeIva, total: total });

    return { total, importeBase, importeIva, iva };
  }

  getLockerType(type) {
    const { t, i18n } = this.props

    switch (type) {
      case "BNS":
        return "Standard";
      case "CNS":
        return "Standard Carga";
      case "BWS":
        return "Standard XL";
      case "BNM":
        return "Medium";
      case "CNM":
        return "Medium Carga";
      case "BWM":
        return "Medium XL";
      case "CWM":
        return "Medium Carga XL";
      case "BNL":
        return "Large";
      case "CNL":
        return "Large Carga";
      case "BWL":
        return "Large XL";
      case "CWL":
        return "Large Carga XL";
      case "BNXL":
        return "Large";
      case "CNXL":
        return "Large Carga";
      case "BWXL":
        return "Large XL";
      case "CWXL":
        return "Large Carga XL";
      case "BN2XL":
        return "Large";
      case "CN2XL":
        return "Large Carga";
      case "BW2XL":
        return "Large XL";
      case "CW2XL":
        return "Large Carga XL";
      case "BN3XL":
        return "Ski";
      case "CN3XL":
        return "Ski Carga";
      case "BW3XL":
        return "Ski XL";
      case "BW3XL":
        return "Ski Carga XL";
      default:
        return "None";
    }
  }

  redsysForm() {

    const { redsys, redsysSignature, redsysMerchant, redsysVersion, minutes, seconds, newLockerPrice } = this.state;
    const { descriptionZone, zoneSelected, selectedLocker, lockerPrice, lockerAssigned, qr, qrType, prerentCode, startDate, endDate, customerName, mail, phoneNumber, customerId } = this.props.location.state;

    const { t, i18n } = this.props

    const buttonStyle = this.getButtonStyle();
    const iconsColor = this.getIconColor();

    const paymentId = Math.floor((Math.random() * 1000000) + 1).toString();
    const productionUrl = "https://sis.redsys.es/sis/realizarPago"
    const testUrl = "https://sis-t.redsys.es:25443/sis/realizarPago"

    const iappaURL = `https://lockers-qr.vacway.es/PhoneView?descriptionZone=${descriptionZone}&zoneSelected=${zoneSelected}&selectedLocker=${selectedLocker}&lockerAssigned=${lockerAssigned}&lockerPrice=${newLockerPrice}&paymentId=${paymentId}&qrToken=${qr}&qrType=${qrType}`

    let redsysURLOK = `https://lockers-qr.vacway.es/TicketRentalView?descriptionZone=${descriptionZone}&zoneSelected=${zoneSelected}&selectedLocker=${selectedLocker}&lockerAssigned=${lockerAssigned}&lockerPrice=${newLockerPrice}&paymentId=${paymentId}&qrToken=${qr}&language=${i18n.language}&prerentCode=${prerentCode}&startDate=${startDate.toLocaleDateString()}&endDate=${endDate.toLocaleDateString()}&customerName=${encodeURIComponent(customerName)}&mail=${encodeURIComponent(mail)}&phoneNumber=${encodeURIComponent(phoneNumber)}&customerId=${customerId}`

    const handleButtonClick = () => {
      window.location.href = redsysURLOK;
    };

    if (!redsys || !redsysSignature || !redsysMerchant || !redsysVersion) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    } else {

      if (qrType === "pay") {
        return (
          <html>
            <body>
              <form action={productionUrl} method="POST" accept-charset="UTF-8" name="peticionRedsys">
                <input type="hidden" name="Ds_SignatureVersion" value={`${redsysVersion}`} />
                <input type="hidden" name="Ds_MerchantParameters" value={`${redsysMerchant}`} />
                <input type="hidden" name="Ds_Signature" value={`${redsysSignature}`} />
                <input type="submit" value={t('Pagar')} className="col lockerRentalPayButton" style={buttonStyle} />
              </form>
            </body>
          </html>
        );
      } else if (qrType === "free") {
        return (
          <html>
            <body>
              <form method="POST" accept-charset="UTF-8" name="peticionRedsys">
                <input type="hidden" name="Ds_SignatureVersion" value={`${redsysVersion}`} />
                <input type="hidden" name="Ds_MerchantParameters" value={`${redsysMerchant}`} />
                <input type="hidden" name="Ds_Signature" value={`${redsysSignature}`} />
                <input type="button" value={t('Reservar')} className="col lockerRentalPayButton" style={buttonStyle} onClick={handleButtonClick} />
              </form>
            </body>
          </html>
        );
      } else if (qrType === "test") {
        return (
          <html>
            <body>
              <form action={testUrl} method="POST" accept-charset="UTF-8" name="peticionRedsys">
                <input type="hidden" name="Ds_SignatureVersion" value={`${redsysVersion}`} />
                <input type="hidden" name="Ds_MerchantParameters" value={`${redsysMerchant}`} />
                <input type="hidden" name="Ds_Signature" value={`${redsysSignature}`} />
                <input type="submit" value={t('TEST')} className="col lockerRentalPayButton" style={buttonStyle} />
              </form>
            </body>
          </html>
        );
      } else {
        return (
          <html>
            <body>
              <form action={productionUrl} method="POST" accept-charset="UTF-8" name="peticionRedsys">
                <input type="hidden" name="Ds_SignatureVersion" value={`${redsysVersion}`} />
                <input type="hidden" name="Ds_MerchantParameters" value={`${redsysMerchant}`} />
                <input type="hidden" name="Ds_Signature" value={`${redsysSignature}`} />
                <input type="submit" value={t('Pagar')} className="col lockerRentalPayButton" style={buttonStyle} />
              </form>
            </body>
          </html>
        );
      }
    }
  }

  render() {
    const { t, i18n, qrData } = this.props
    const { redsys, iva, importeBase, importeIva, total, minutes, seconds, isTimeUp, discountApplied } = this.state;
    const { descriptionZone, selectedLocker, lockerAssigned, startDate, endDate, customerName, mail, phoneNumber, lockerPrice } = this.props.location.state;

    const iconsColor = this.getIconColor();
    const buttonStyle = this.getButtonStyle();

    if (!redsys) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    } else {
      return (
        <div className="rentalBackground">
          <AppRentalHeader />
          <div className="lockerContainer smartphone">
            <br></br>
            <h3 className="lockTitle">
              <span className="text-vw-dark">{t('CONFIRMA TU COMPRA')}</span>
            </h3>
            <div className="text-vw-semidark text-center">
              {t('Tiempo para confirmar')}: {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
            </div>
            <br></br>

            <div className="unified-form">
              <CreditCard className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

              <div className="lockTitle">
                <span className="text-vw-semidark">{t('Confirma los importes')}</span>
              </div>

              {/* DISCOUNTS */}
              {discountApplied &&
                <div className="rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t('Te hemos aplicado un descuento en el precio, solo vas a pagar 5 días de tu reserva!')}</span>
                    <span className="rental-uf-output">{descriptionZone}</span>
                  </div>
                </div>
              }
              {discountApplied &&
                <div className="rental-uf-row no-border">
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t('Importe Original')}</span>
                    <span className="rental-uf-output">{lockerPrice.toFixed(2)}€</span>
                  </div>
                </div>
              }

              {/* BASE */}
              <div className="mt-2 rental-uf-row no-border">
                <div className='d-flex'>
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t('Base')}</span>
                    <span className="rental-uf-output">{importeBase}€</span>
                  </div>
                  <vr class="vr"></vr>
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t('IVA')} ({iva}%)</span>
                    <span className="rental-uf-output">{importeIva}€</span>
                  </div>
                  <vr class="vr"></vr>
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t('Total')}</span>
                    <span className="rental-uf-output">{total}€</span>
                  </div>
                </div>
              </div>
              {/* CONTINUE */}
              <div className="uf-actions">
                {this.redsysForm()}
              </div>
            </div>
            <div className="mt-4 unified-form">
              <FileCheck className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

              <div className="lockTitle">
                <span className="text-vw-semidark">{t('Revisa los datos de tu reserva')}</span>
              </div>

              {/* ZONE */}
              <div className="mt-2 rental-uf-row no-border">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t('Zona')}</span>
                  <span className="rental-uf-output">{descriptionZone}</span>
                </div>
              </div>
              {/* DATES */}
              <div className="rental-uf-row no-border">
                <div className='d-flex'>
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t('Inicio')}</span>
                    <span className="rental-uf-output">{startDate ? startDate.toLocaleDateString() : ""}</span>
                  </div>
                  <vr class="vr"></vr>
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t('Fin')}</span>
                    <span className="rental-uf-output">{endDate ? endDate.toLocaleDateString() : ""}</span>
                  </div>
                </div>
              </div>
              <div className="rental-uf-row no-border">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t('Hora Límite')}</span>
                  <span className="rental-uf-output">23:59</span>
                </div>
              </div>
              {/* LOCKER */}
              <div className="rental-uf-row no-border">
                <div className='d-flex'>
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t('Taquilla')}</span>
                    <span className="rental-uf-output">{this.getLockerType(selectedLocker)}</span>
                  </div>
                  <vr class="vr"></vr>
                  <div className="rental-uf-btn">
                    <span className="rental-uf-label">{t('Cantidad')}</span>
                    <span className="rental-uf-output">{lockerAssigned.length}</span>
                  </div>
                </div>
              </div>
              {/* NAME */}
              <div className="rental-uf-row no-border">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t('Nombre')}</span>
                  <span className="rental-uf-output">{customerName}</span>
                </div>
              </div>
              {/* EMAIL */}
              <div className="rental-uf-row no-border">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t('Email')}</span>
                  <span className="rental-uf-output">{mail}</span>
                </div>
              </div>
              {/* PHONE */}
              <div className="rental-uf-row no-border">
                <div className="rental-uf-btn">
                  <span className="rental-uf-label">{t('Teléfono')}</span>
                  <span className="rental-uf-output">+{phoneNumber}</span>
                </div>
              </div>
            </div>

            <StepBarRental step={4} />
          </div>

          <div className="lockerContainer pc">
            <h3 className="lockTitle">
              <span className="text-vw-dark">{t('CONFIRMA TU COMPRA')}</span>
            </h3>
            <div className="lockTitle">
              <span className="text-vw-semidark">{t('Tiempo para confirmar')}: {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}</span>
            </div>
            <div className='rental-payForm'>
              <div className="col-8">
                <div className="unified-form">
                  <FileCheck className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

                  <div className="lockTitle">
                    <span className="text-vw-semidark">{t('Revisa los datos de tu reserva')}</span>
                  </div>

                  {/* ZONE */}
                  <div className="mt-2 rental-uf-row no-border">
                    <div className='d-flex'>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Zona')}</span>
                        <span className="rental-uf-output">{descriptionZone}</span>
                      </div>
                      <vr class="vr"></vr>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Taquilla')}</span>
                        <span className="rental-uf-output">{this.getLockerType(selectedLocker)}</span>
                      </div>
                      <vr class="vr"></vr>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Cantidad')}</span>
                        <span className="rental-uf-output">{lockerAssigned.length}</span>
                      </div>
                    </div>
                  </div>
                  {/* DATES */}
                  <div className="rental-uf-row no-border">
                    <div className='d-flex'>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Inicio')}</span>
                        <span className="rental-uf-output">{startDate ? startDate.toLocaleDateString() : ""}</span>
                      </div>
                      <vr class="vr"></vr>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Fin')}</span>
                        <span className="rental-uf-output">{endDate ? endDate.toLocaleDateString() : ""}</span>
                      </div>
                      <vr class="vr"></vr>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Hora Límite')}</span>
                        <span className="rental-uf-output">23:59</span>
                      </div>
                    </div>
                  </div>
                  {/* NAME */}
                  <div className="rental-uf-row no-border">
                    <div className='d-flex'>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Nombre')}</span>
                        <span className="rental-uf-output">{customerName}</span>
                      </div>
                      <vr class="vr"></vr>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Email')}</span>
                        <span className="rental-uf-output">{mail}</span>
                      </div>
                      <vr class="vr"></vr>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Teléfono')}</span>
                        <span className="rental-uf-output">+{phoneNumber}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-4">
                <div className="unified-form">
                  <CreditCard className="rental-phoneIcon" strokeWidth={1} style={{ color: iconsColor }} />

                  <div className="lockTitle">
                    <span className="text-vw-semidark">{t('Confirma los importes')}</span>
                  </div>

                  {/* DISCOUNTS */}
                  {discountApplied &&
                    <div className="rental-uf-row no-border">
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Te hemos aplicado un descuento en el precio, solo vas a pagar 5 días de tu reserva!')}</span>
                        <span className="rental-uf-output">{descriptionZone}</span>
                      </div>
                    </div>
                  }
                  {discountApplied &&
                    <div className="rental-uf-row no-border">
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Importe Original')}</span>
                        <span className="rental-uf-output">{lockerPrice.toFixed(2)}€</span>
                      </div>
                    </div>
                  }

                  {/* BASE */}
                  <div className="mt-2 rental-uf-row no-border">
                    <div className='d-flex'>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('Base')}</span>
                        <span className="rental-uf-output">{importeBase}€</span>
                      </div>
                      <vr class="vr"></vr>
                      <div className="rental-uf-btn">
                        <span className="rental-uf-label">{t('IVA')} ({iva}%)</span>
                        <span className="rental-uf-output">{importeIva}€</span>
                      </div>
                    </div>
                  </div>
                  {/* TOTAL */}
                  <div className="rental-uf-row no-border">
                    <div className="rental-uf-btn">
                      <span className="rental-uf-label">{t('Total')}</span>
                      <span className="rental-uf-output">{total}€</span>
                    </div>
                  </div>
                  {/* CONTINUE */}
                  <div className="uf-actions">
                    {this.redsysForm()}
                  </div>
                </div>
              </div>
            </div>
            <br></br>
            <StepBarRental step={4} />
          </div>
          <div>
            <Modal isOpen={isTimeUp}>
              <ModalHeader>
                {t('Tiempo de reserva agotado')}
              </ModalHeader>
              <ModalBody>
                {t('Lo sentimos, pero no podemos reservar tu taquilla por más tiempo, otros usuarios deben poder acceder a ella. Vuelve a iniciar el proceso y finaliza la compra en el tiempo estipulado.')}
              </ModalBody>
              <ModalFooter>
                <Button className="button-center"
                  style={buttonStyle}
                  onClick={this.handleRedirect}>
                  {t('Volver al inicio')}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  auth: true,
  redsys: state.redsys,
  qrData: state.qrs.qr,
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  postRedsys: bindActionCreators(postRedsys, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PaymentRentalView));